import styled from 'styled-components'

export const FeaturesSec = styled.section`
  padding: clamp(48px, 7vw, 90px) 0;
  background-color: #7aff6b;
  overflow: hidden;
`

export const FeaturesRow = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-left: 4px;
  padding: 8px 4px 20px;
  cursor: grab;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  &.dragging {
    cursor: grabbing;
    scroll-snap-type: none;
    user-select: none;
  }
`

export const Card = styled.div`
  /* mobile: 1 card + "espiada" do próximo; tablet: 2; desktop: 3 */
  flex: 0 0 85%;
  scroll-snap-align: start;
  background: #001d07;
  border-radius: 18px;
  padding: clamp(22px, 3vw, 32px);
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 12px 28px rgba(0, 29, 7, 0.25);
  transition: transform 0.3s ease;

  @media screen and (min-width: 600px) {
    flex-basis: calc((100% - 20px) / 2);
  }

  @media screen and (min-width: 1000px) {
    flex-basis: calc((100% - 40px) / 3);
  }

  @media (hover: hover) {
    &:hover {
      transform: translateY(-4px);
    }
  }
`

export const CardImg = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 16px;
  border-radius: 20px;
  pointer-events: none;
  user-select: none;
`

export const Heading = styled.h2`
  max-width: 900px;
  margin: 0 auto clamp(24px, 4vw, 40px);
  font-size: clamp(26px, 4vw, 44px);
  color: #002107;
  line-height: 1.15;
  font-weight: 700;
  text-align: center;
`;

export const CardTitle = styled.h3`
  font-size: clamp(18px, 1.9vw, 22px);
  line-height: 1.3;
  font-weight: 700;
  margin-bottom: 10px;
  overflow-wrap: break-word;
`

export const CardText = styled.p`
  font-size: clamp(16px, 1.6vw, 18px);
  line-height: 1.5;
  color: #d1d0d0;
`

export const Dots = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
  gap: 4px;

  button {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: rgba(0, 29, 7, 0.3);
    transition: all 0.3s ease;
  }

  button.active::after {
    width: 24px;
    background: #001d07;
  }
`
